import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import TabsNavbar from "../../Common/TabsNavBar/TabsNavbar";
import ModifyOrderContent from "./ModifyOrderContent";
import ShadowLoader from "../../../Utils/ViewWrapper/ShadowLoader/ShadowLoader";
import { openRightModal } from "../../../REDUX/actions/rightModal";
import UpdateTicketSav from "../../Sav/UpdateTicketSavAdmin/UpdateTicketSav";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { fetchCommande } from "../../../REDUX/actions/commandes";

import "./ModifyOrder.css";
import { useTranslation } from "react-i18next";
import { isDefined } from "../../../Utils";
import { getFavorites, resetFavorites } from "../../../REDUX/actions/favorites";

function ModifyOrder({ id, initialTab = "General information", savID }) {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);
  const [disabled, setdisabled] = useState(false);
  const [activeTab, setActiveTab] = useState(initialTab);
  const [formData, setFormData] = useState({});
  const [commandesTabUpdated, setcommandesTabUpdated] = useState();
  const [deletedPackings, setdeletedPackings] = useState([]);
  const { invoicesLoading } = useSelector((state) => state.invoicesReducer);
  const { favorites } = useSelector((state) => state.favoriteReducer);

  // const { order, orderLoading, orderError, orderReload } = useSelector(
  //   (state) => state.ordersReducer
  // );

  const {
    commande: order,
    commandeLoading,
    commandeRefetchLoading,
    commandeError,
    updateOrderPaysLoading,
  } = useSelector((state) => state.commandeReducer);

  const location = useLocation();

  const isAdmin =
    user?.attributes?.userRole === 1 || user?.attributes?.userRole === 2;
  const tabs = isAdmin
    ? ["General information", "Comments", "Payments"]
    : user?.attributes?.userRole === 7
      ? ["General information"] // a store's commercial
      : ["General information", "Comments"];

  if (favorites?.length > 0) {
    tabs.push("Favorites");
  }

  useEffect(() => {
    dispatch(fetchCommande(id));
  }, [id, dispatch]);

  // useEffect(() => {
  //   dispatch(getOneOrder({ id }));
  // }, [dispatch, id, orderReload]);

  useEffect(() => {
    setFormData({
      ...order,
      payments: order?.payments || [],
    });
  }, [order, commandeRefetchLoading, activeTab]);

  useEffect(() => {
    return () => {
      dispatch({ type: "CLEAR_ORDER" });
    };
  }, [dispatch]);

  useEffect(() => {
    if (!isDefined(id)) return;

    dispatch(getFavorites(id, "commande"));

    return () => dispatch(resetFavorites());
  }, [id, dispatch]);

  useEffect(() => {
    if (formData?.payments) {
      for (const payment of formData?.payments) {
        if (payment?.amount === 0 || payment?.date === undefined) {
          activeTab === t("Payments") && setdisabled(true);
        }
      }
    }
    if (!formData?.number) setdisabled(true);

    return () => {
      setdisabled(false);
    };
  }, [formData, activeTab]);

  return (
    <div className="modifyOrder d-flex flex-column justify-content-between h100">
      <div>
        <div className="alignH align-items-end">
          {location.pathname === "/sav" && (
            <FontAwesomeIcon
              icon={faArrowLeftLong}
              size={"xl"}
              className="ps-5 mb-5 pointer text-blue"
              onClick={() =>
                dispatch(openRightModal(<UpdateTicketSav id={savID} />))
              }
            />
          )}

          <h2
            className={`sBold f25 quickSand text-blue ${
              location.pathname === "/sav" ? "px-3" : "px-5"
            } mb-5`}
          >
            {isAdmin
              ? `${t("Modify the order")} #${order?.number}`
              : `${t("Order")} #${order?.number}`}
          </h2>
        </div>
        <TabsNavbar
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          className="gap-5"
        />
        <ShadowLoader
          loading={commandeLoading || invoicesLoading || updateOrderPaysLoading}
          error={commandeError}
        >
          <ModifyOrderContent
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            formData={formData}
            setFormData={setFormData}
            setcommandesTabUpdated={setcommandesTabUpdated}
            commandesTabUpdated={commandesTabUpdated}
            deletedPackings={deletedPackings}
            setdeletedPackings={setdeletedPackings}
            order={order}
          />
        </ShadowLoader>
      </div>
      {/* {activeTab !== "Commentaires" && (
        <div className="buttonsContainer d-flex justify-content-center mt-5">
          <Button
            variant="outline"
            className="me-4"
            onClick={() => dispatch(closeRightModal())}
          >
            Annuler
          </Button>
          <Button onClick={handleSubmit} disabled={disabled}>
            Enregistrer
          </Button>
        </div>
      )} */}
    </div>
  );
}

export default ModifyOrder;
